export const HEADER = {
  W_MOBILE: '100%',
  W_DESKTOP: 1440,
  H_MOBILE: 72,
  H_DESKTOP: 140,
  H_DESKTOP_OFFSET: 140 - 16,
};

export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 88,
};
